import { Box, Divider, Drawer,BoxProps  } from '@mui/material';
import { styled, alpha, lighten } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';

interface SidebarWrapperProps extends BoxProps {
  collapsed?: boolean;
}

interface FixedSidebarWrapperProps extends BoxProps {
  collapsed?: boolean;
  children?: React.ReactNode;
}

export const SidebarToggle = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '40%',
  transform: 'translateY(-50%)',
  right: '-12px',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '50%',
  width: 32,
  height: 32,
  zIndex: 10,
  boxShadow: theme.shadows[1],
  transition: 'background-color 0.3s',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));


export const SidebarWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<SidebarWrapperProps>(({ theme, collapsed }) => `
  width: ${collapsed ? '50px' : theme.sidebar.width};
  min-width: ${collapsed ? '50px' : theme.sidebar.width};
  color: ${theme.colors.alpha.trueWhite[70]};
  position: relative;
  z-index: 7;
  height: 100%;
  padding-bottom: 68px;
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* Ensure the sidebar is scrollable */
`
);

export const FixedSidebarWrapper = styled(
  ({ collapsed, children, ...rest }: FixedSidebarWrapperProps) => (
    <SidebarWrapper collapsed={collapsed} {...rest}>
      {children}
    </SidebarWrapper>
  )
)(({ theme }) => `
  display: inline-block;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
   background: ${
          theme.palette.mode === 'dark'
            ? alpha(lighten(theme.header.background ?? '#fff', 0.1), 0.5)
            : "#fff"
        };
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 16px;
  box-shadow: 0px 4px 22.4px rgba(0, 0, 0, 0.06);
`);

export const DrawerWrapper = styled(Drawer)(
  ({ theme }) => `
        &.MuiDrawer-paper {
            overflow: auto;
        }
        box-shadow: ${theme.sidebar.boxShadow};
`
);

export const DividerStyled = styled(Divider)(
  ({ theme }) => `
        background: ${theme.colors.alpha.trueWhite[10]};
        margin-top: ${theme.spacing(3)};
        margin-left: ${theme.spacing(2)};
        margin-right: ${theme.spacing(2)};
`
);

export const SidebarProfileWrapper = styled('div')({
  display: 'flex',
  marginTop: "34px"
});

export const SidebarProfile = styled('div')({
  width: "48px",
  height: "48px",
  borderRadius: "50%"
});

export const SidebarProfileImg = styled('img')({
  width: "48px",
  height: "48px",
  objectFit: "cover",
  borderRadius: "50%"
});

export const SidebarProfileInfo = styled('div')({
  marginLeft: "5.17px"
});

export const SidebarProfileInfoName = styled('div')({
  fontSize: "14px",
  fontWeight: "600",
  color: "#000",
  lineHeight: "112.2%"
});

export const SidebarProfileInfoEmail = styled('div')({
  fontSize: "12px",
  fontWeight: "500",
  color: "#9E9E9E",
  marginTop: "2px"
});

export const SingoutWrapper = styled('div')({
  marginTop: "5px",
  display: "flex",
  cursor: "pointer",
});

export const SingoutLabel = styled('div')({
  fontSize: "12px",
  color: "#EB0A1E",
  fontWeight: "600",
  marginLeft: "3px"
});

export const HeaderLink = styled(Link)(() => `
  text-decoration: none;
  color: #000000;
  font-size: 14px;

  &.header-link-selected {
    color: #EB0A1E;
  }
`);

export const HeaderInner = styled('div')({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  alignItems: "center",
});

export const HeaderInnerLeft = styled('ul')({
  padding: 0,
  listStyle: "none",
  display: "flex",
  gap: "18px",
  alignItems: "center",
});

export const HeaderInnerRight = styled('div')({
  fontSize: "14px",
  color: "black",
  display: "flex",
  alignItems: "center",
});

export const NeedHelpImg = styled('img')({
  marginRight: "4px"
});

export const ContactLink = styled('a')({
  color: "#EB0A1E",
  fontWeight: "600",
  textDecoration: "none",
});
